import { render, staticRenderFns } from "./clearDatas.vue?vue&type=template&id=18594a0e&"
import script from "./clearDatas.vue?vue&type=script&lang=js&"
export * from "./clearDatas.vue?vue&type=script&lang=js&"
import style0 from "./clearDatas.vue?vue&type=style&index=0&lang=less&scope=true&"
import style1 from "./clearDatas.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "clearDatas.vue"
export default component.exports